module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\">\n  <path d=\"M10 9h16v2H10zM10 13h16v2H10zM10 17h16v2H10zM10 21h16v2H10zM10 25h16v2H10z\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/list.svg
// module id = 803
// module chunks = 1